import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import SubscriptionGrid from '../../organisms/Subscriptions';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flex: 1
  }
}));

const Subscriptions = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <SubscriptionGrid></SubscriptionGrid>
    </div>
  );
}

export default Subscriptions;